module.exports = __webpack_public_path__ + "img/lg-mit-app-inventor-2.5614ca97.jpg";